module.exports = __webpack_public_path__ + "img/system_on.54bb5f31.png";